/* ─────────────────────────────────────────────
   AUTO LOAD LANGUAGE
   return ARRAY
───────────────────────────────────────────── */

export const loadMenuLanguage = async (
    lang = "en"
) => {

    try {

        /* import langue */
        const menuModule = await import(
            `./menuElakay_${lang}.json`
        );

        const menuElakay = menuModule?.default;
        /* verification */
        if (
            !Array.isArray(menuElakay) ||
            menuElakay.length === 0 ||
            typeof menuElakay[0] !== "object"
        ) {

            throw new Error(
                `menuElakay_${lang}.json invalid`
            );
        }

        /* RETURN ARRAY */
        return menuElakay[0];

    } catch (err) {

        console.warn(
            `Language ${lang} failed -> fallback EN`,
            err
        );

        try {

            /* fallback english */
            const enModule = await import(
                "./menuElakay_en.json"
            );

            const englishMenu = enModule?.default;

            if (
                !Array.isArray(englishMenu)
            ) {
                return [];
            }

            return englishMenu[0];

        } catch (enErr) {

            console.error(
                "English fallback failed",
                enErr
            );

            return [];
        }
    }
};